import * as St from '../styles';

export interface CardStatusProps {
  loading?: boolean;
  error?: string;
}

interface Props extends CardStatusProps {
  /** Altura mínima do conteúdo, para o card não mudar de tamanho ao carregar. */
  height?: number;
  children: React.ReactNode;
}

// Cada card mostra o próprio loading e erro, sem esperar os outros recursos.
const CardStatus: React.FC<Props> = ({
  loading = false,
  error,
  height = 160,
  children,
}) => {
  if (loading) {
    return (
      <St.CardStatus height={height} role="status" aria-live="polite">
        <St.Spinner />
        <span>Carregando...</span>
      </St.CardStatus>
    );
  }
  if (error) {
    return (
      <St.CardStatus height={height} error role="alert">
        {error}
      </St.CardStatus>
    );
  }
  return <>{children}</>;
};

export default CardStatus;
